import { getPhaseData } from '../../data/programData';
import { CheckCircle, Trophy, Clock, Dumbbell } from 'lucide-react';
import { Button } from '../ui';

export function SessionComplete({
  phaseNum,
  workoutNum,
  sessionState,
  supersets,
  onFinish
}) {
  const phaseData = getPhaseData(phaseNum);
  
  const completedCount = sessionState.completedSupersets?.length || 0;
  const totalCount = supersets.length;
  
  // Calculate session duration
  const startTime = new Date(sessionState.startedAt);
  const endTime = sessionState.completedAt ? new Date(sessionState.completedAt) : new Date();
  const durationMs = endTime - startTime;
  const durationMins = Math.round(durationMs / 60000);

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-6">
      <div className="text-center max-w-md">
        {/* Success Icon */}
        <div className="h-24 w-24 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-6">
          <Trophy className="h-12 w-12 text-green-600" />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Workout Complete!
        </h1>
        <p className="text-gray-500 mb-8">
          Great job finishing {phaseData?.title} - Session {workoutNum}
        </p>

        {/* Stats */}
        <div className="grid grid-cols-2 gap-4 mb-8">
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
            <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center mx-auto mb-2">
              <Dumbbell className="h-5 w-5 text-blue-600" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{completedCount}/{totalCount}</p>
            <p className="text-sm text-gray-500">Supersets</p>
          </div>
          
          <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
            <div className="h-10 w-10 rounded-full bg-purple-100 flex items-center justify-center mx-auto mb-2">
              <Clock className="h-5 w-5 text-purple-600" />
            </div>
            <p className="text-2xl font-bold text-gray-900">{durationMins}</p>
            <p className="text-sm text-gray-500">Minutes</p>
          </div>
        </div>

        {/* Completion Message */}
        <div className="bg-green-50 border border-green-200 rounded-xl p-4 mb-8">
          <div className="flex items-center justify-center text-green-700">
            <CheckCircle className="h-5 w-5 mr-2" />
            <span className="font-medium">Session saved to your progress</span>
          </div>
        </div>

        {/* Finish Button */}
        <Button onClick={onFinish} fullWidth size="lg">
          Done
        </Button>
      </div>
    </div>
  );
}